// https://github.com/Financial-Times/polyfill-library/blob/46f183701399f7f81ae409c7f5a536edf2817902/polyfills/Function/prototype/bind/polyfill.js

if (!detect()) invokeIframePolyfill()
if (!detect()) invokeCustomPolyfill()
if (!detect()) console.error('Function.prototype.bind is not compatible with gleam-gallery!')

function detect() {
  try {
    const instance = new (Function.prototype.bind.apply(Class, [null, 0, 1]))()
    return true
      && instance.self instanceof Class
      && instance.self.foo === 'bar'
      && instance.args.length === 2
      && instance.args[0] === 0
      && instance.args[1] === 1
  } catch (_err) {
    return false
  }

  function Class() {
    this.foo = 'bar'
    return { self: this, args: arguments }
  }
}

function invokeIframePolyfill() {
  try {
    const iframe = document.createElement('iframe')
    document.body.appendChild(iframe)
    Function.prototype.bind = iframe.contentWindow.Function.prototype.bind
    Function.prototype.bind._iframe = true
    document.body.removeChild(iframe)
  } catch (_err) {
    /* ignore error */
  }
}

function invokeCustomPolyfill() {
  Object.defineProperty(Function.prototype, 'bind', {
    value(that) {
      const $Array = Array
      const $Object = Object
      const ArrayPrototype = $Array.prototype
      const Empty = function Empty() { /* empty */ }
      const array_slice = ArrayPrototype.slice
      const array_concat = ArrayPrototype.concat
      const array_push = ArrayPrototype.push
      const max = Math.max

      const target = this
      if (!IsCallable(target)) {
        throw new TypeError('Function.prototype.bind called on incompatible ' + target)
      }

      const args = array_slice.call(arguments, 1)
      let bound = undefined
      const binder = function() {
        if (this instanceof bound) {
          const result = target.apply(
            this,
            array_concat.call(args, array_slice.call(arguments))
          )
          if ($Object(result) === result) {
            return result
          }
          return this
        } else {
          return target.apply(
            that,
            array_concat.call(args, array_slice.call(arguments))
          )

        }

      }

      const boundLength = max(0, target.length - args.length)

      const boundArgs = []
      for (let i = 0; i < boundLength; i++) {
        array_push.call(boundArgs, '$' + i)
      }

      bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder)

      if (target.prototype) {
        Empty.prototype = target.prototype
        bound.prototype = new Empty()
        Empty.prototype = null
      }

      return bound
    },
    configurable: true,
    writable: true
  })
}

/* IsCallable */

function IsCallable(value) {
  if (!value) {
    return false
  }
  if (typeof value !== 'function' && typeof value !== 'object') {
    return false
  }
  if (typeof value === 'function' && !value.prototype) {
    return true
  }
  const hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol'
  if (hasToStringTag) {
    return tryFunctionObject(value)
  }
  if (isES6ClassFn(value)) {
    return false
  }
  const strClass = Object.prototype.toString.call(value)
  const fnClass = '[object Function]'
  const genClass = '[object GeneratorFunction]'
  return strClass === fnClass || strClass === genClass
}

function isES6ClassFn(value) {
  try {
    const fnStr = Function.prototype.toString.call(value)
    const constructorRegex = /^\s*class\b/
    return constructorRegex.test(fnStr)
  } catch (_err) {
    return false
  }
}

function tryFunctionObject(value) {
  try {
    if (isES6ClassFn(value)) {
      return false
    }
    Function.prototype.toString.call(value)
    return true
  } catch (_err) {
    return false
  }
}
